export default function initResetPasswordCooldown() {
  const btn = document.getElementById('resetPasswordSubmit')
  if (!btn) return

  let remaining = parseInt(btn.dataset.cooldown, 10) || 0
  if (remaining <= 0) return
  if (remaining > 60) remaining = 60

  const originalText = btn.value
  let intervalId = null

  const render = () => {
    if (remaining > 0) {
      btn.disabled = true
      btn.value = `${originalText} (${remaining})`
    } else {
      btn.disabled = false
      btn.value = originalText
      if (intervalId) { clearInterval(intervalId); intervalId = null }
    }
  }

  render()
  intervalId = setInterval(() => { remaining -= 1; render() }, 1000)
}
